<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

import SidenavItem from "./SidenavItem.vue";
import SidenavCollapse from "./SidenavCollapse.vue";
import SidenavCard from "./SidenavCard.vue";
import SidenavCollapseItem from "./SidenavCollapseItem.vue";

const store = useStore();

const getRoute = () => {
  const route = useRoute();
  const routeArr = route.path.split("/");
  return routeArr[1];
};

// Computed para verificar si el usuario tiene rol CEO
const isCEO = computed(() => {
  const user = store.state.user;
  if (!user || !user.roles) return false;
  return user.roles.some(role => role.name === 'CEO' || role.name === 'ceo');
});
</script>
<template>
  <div id="sidenav-collapse-main" class="collapse navbar-collapse w-auto h-auto h-100">
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-collapse
collapse-ref="dashboardsExamples" nav-text="Dashboards"
          :class="getRoute() === 'dashboards' ? 'active' : ''">
          <template #icon>
            <i class="ni ni-shop text-primary text-sm opacity-10"></i>
          </template>
          <template #list>
            <ul class="nav ms-4">
              <!-- nav links -->
              <!-- <sidenav-item :to="{ name: 'Landing' }" mini-icon="L" text="Landing" />
              <sidenav-item :to="{ name: 'Default' }" mini-icon="D" text="Default" />
              <sidenav-item :to="{ name: 'Automotive' }" mini-icon="A" text="Automotive" />
              <sidenav-item :to="{ name: 'Smart Home' }" mini-icon="S" text="Smart Home" />
              <sidenav-collapse-item refer="vrExamples" mini-icon="V" text="Virtual Reality">
                <template #nav-child-item>
                  <sidenav-item :to="{ name: 'VR Default' }" mini-icon="V" text="VR Default" />
                  <sidenav-item :to="{ name: 'VR Info' }" mini-icon="V" text="VR Info" />
                </template>
</sidenav-collapse-item>
<sidenav-item :to="{ name: 'CRM' }" mini-icon="C" text="CRM" /> -->
            </ul>
          </template>
        </sidenav-collapse>
      </li>
      <li class="mt-3 nav-item">
        <h6
class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
          :class="store.state.isRTL ? 'me-4' : 'ms-2'">
          Pac
        </h6>
      </li>
      <li class="nav-item">
        <sidenav-collapse
collapse-ref="ExpedientesExamples" nav-text="Expedientes"
          :class="getRoute() === 'expedientes' ? 'active' : ''">
          <template #icon>
            <i class="ni ni-ungroup text-warning text-sm opacity-10"></i>
          </template>
          <template #list>
            <ul class="nav ms-4">
              <!-- nav links -->
              <sidenav-item :to="{ name: 'Pacientes' }" mini-icon="P" text="Pacientes" />
              <sidenav-item :to="{ name: 'Expedientes' }" mini-icon="R" text="Expedientes" />
              <sidenav-item :to="{ name: 'ReservationManager' }" mini-icon="C" text="Calendario" />
            </ul>
          </template>
        </sidenav-collapse>
      </li>

      <li class="mt-3 nav-item">
        <h6
class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
          :class="store.state.isRTL ? 'me-4' : 'ms-2'">
          PAGES
        </h6>
      </li>

      <li class="nav-item">
        <sidenav-collapse collapse-ref="pagesExamples" nav-text="Pos" :class="getRoute() === 'pos' ? 'active' : ''">
          <template #icon>
            <i class="ni ni-ungroup text-warning text-sm opacity-10"></i>
          </template>
          <template #list>
            <ul class="nav ms-4">
              <!-- nav links -->
              <sidenav-item :to="{ name: 'Sales' }" mini-icon="V" text="Ventas" />

              <sidenav-collapse-item refer="profileExample" mini-icon="I" text="Items">
                <template #nav-child-item>
                  <sidenav-item :to="{ name: 'Items' }" mini-icon="L" text="Lista" />
                  <sidenav-item :to="{ name: 'ItemsCategories' }" mini-icon="C" text="Categorias" />
                </template>
              </sidenav-collapse-item>


            </ul>
          </template>
        </sidenav-collapse>
      </li>

      <li class="nav-item">
        <sidenav-collapse
collapse-ref="applicationsExamples" nav-text="Sistemas"
          :class="getRoute() === 'applications' ? 'active' : ''">
          <template #icon>
            <i class="ni ni-ui-04 text-info text-sm opacity-10"></i>
          </template>
          <template #list>
            <ul class="nav ms-4">
              <!-- nav links -->
              <sidenav-item :to="{ name: 'Invoices' }" mini-icon="FAC" text="Facturas" />
            </ul>
            <ul class="nav ms-4">
              <!-- nav links -->
              <sidenav-item :to="{ name: 'Payments' }" mini-icon="PAG" text="Pagos" />
            </ul>
            <ul class="nav ms-4">
              <!-- nav links -->
              <sidenav-item :to="{ name: 'Apps' }" mini-icon="IL" text="Instancias Lógicas" />
            </ul>
            <ul class="nav ms-4">
              <!-- nav links -->
              <sidenav-item :to="{ name: 'CentersMedical' }" mini-icon="CM" text="Centros de Trabajo" />
            </ul>
            <ul class="nav ms-4">
              <!-- nav links -->
              <sidenav-item :to="{ name: 'Users' }" mini-icon="USR" text="Usuarios" />
            </ul>
            <ul class="nav ms-4">
              <!-- nav links -->
              <sidenav-item :to="{ name: 'AppsRoles' }" mini-icon="AR" text="Asignar Roles" />
            </ul>
            <ul class="nav ms-4">
              <!-- nav links -->
              <sidenav-item :to="{ name: 'ModulesPermisions' }" mini-icon="AP" text="Asignar Permisos" />
            </ul>
            <ul v-if="isCEO" class="nav ms-4">
              <!-- nav links -->
              <sidenav-item :to="{ name: 'Roles' }" mini-icon="ROL" text="Roles" />
            </ul>
            <ul v-if="isCEO" class="nav ms-4">
              <!-- nav links -->
              <sidenav-item :to="{ name: 'Permissions' }" mini-icon="ROL" text="Permisos" />
            </ul>
            <ul v-if="isCEO" class="nav ms-4">
              <!-- nav links -->
              <sidenav-item :to="{ name: 'Modules' }" mini-icon="MDL" text="Módulos" />
            </ul>
            <ul v-if="isCEO" class="nav ms-4">
              <!-- nav links -->
              <sidenav-item :to="{ name: 'ModulePricing' }" mini-icon="MDL" text="Precio por Módulo" />
            </ul>
            <ul class="nav ms-4">
              <!-- nav links -->
              <sidenav-item :to="{ name: 'SalesBox' }" mini-icon="C" text="Cajas" />
            </ul>
          </template>
        </sidenav-collapse>
      </li>
      <li class="mt-3 nav-item">
        <hr class="mt-0 horizontal dark" />
        <h6
class="text-xs ps-4 ms-2 text-uppercase font-weight-bolder opacity-6"
          :class="store.state.isRTL ? 'me-4' : 'ms-2'">
          DOCS
        </h6>
      </li>
      <li class="nav-item">
        <sidenav-collapse nav-text="Changelog" :collapse="false" url="#" :aria-controls="''" collapse-ref="">
          <template #icon>
            <i
class="ni ni-align-left-2 text-sm" :class="store.state.sidebarType === 'bg-default' || store.state.darkMode
              ? 'text-white'
              : 'text-dark'
              "></i>
          </template>
        </sidenav-collapse>
      </li>
    </ul>
  </div>
  <div class="mt-3 sidenav-footer">
    <sidenav-card
:card="{
      title: 'Need Help?',
      description: 'Please check our docs',
      links: [
        {
          label: 'Documentation',
          route:
            'https://www.creative-tim.com/learning-lab/vue/overview/argon-dashboard/',
          color: 'dark',
        },
        {
          label: 'Buy now',
          route:
            'https://www.creative-tim.com/product/vue-argon-dashboard-pro?ref=vadp',
          color: 'success',
        },
      ],
    }" />
  </div>
</template>
